import initialState from '../initialstate';

export default function documentSettingConfigurationReducer(state = initialState.documentSettingConfiguration, action) {
	switch (action.type) {
		case 'DOCUMENT_GET_CONFIGURATION':
			return action.response;
	}

	return state;
}
